module.exports = __webpack_public_path__ + "static/media/21.25388cd4.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/accessoires/21.png
// module id = 388
// module chunks = 0